import script from "./IntegrationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationModal.vue?vue&type=script&setup=true&lang=js"

import "./IntegrationModal.vue?vue&type=style&index=0&id=62de202f&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62de202f"]])

export default __exports__